import { createAction } from '@reduxjs/toolkit';

import {
  type ContentCollectionAssetAutoSubmitStatus,
  type ContentCollectionClip,
  type ContentCollectionClipWithUpload,
  type ContentCollectionCustomField,
  type ContentCollectionState,
} from './types';

export const setApplyAllAction = createAction<{ applyAll: ContentCollectionState['applyAll'] }>('SET_APPLY_ALL');

export const setCustomFieldsAction = createAction<{ customFields: ContentCollectionState['customFields'] }>(
  'SET_CUSTOM_FIELDS',
);

export const setCustomFieldPlainTextValueAction = createAction<{ customField: ContentCollectionCustomField }>(
  'SET_CUSTOM_FIELD_PLAIN_TEXT_VALUE',
);

export const setCustomFieldDateValueAction = createAction<{ customField: ContentCollectionCustomField }>(
  'SET_CUSTOM_FIELD_DATE_VALUE',
);

export const setCustomFieldValuesAction = createAction<{ customField: ContentCollectionCustomField }>(
  'SET_CUSTOM_FIELD_VALUES',
);

export const setCustomFieldValueAction = createAction<{ customField: ContentCollectionCustomField }>(
  'SET_CUSTOM_FIELD_VALUE',
);

export const setTouchedAction = createAction<{ touched: ContentCollectionState['touched'] }>('SET_TOUCHED');

export const setFormAction = createAction<{ form: ContentCollectionState['form'] }>('SET_FORM');

export const setAttemptedSubmissionAction = createAction<{
  attemptedSubmission: ContentCollectionState['attemptedSubmission'];
}>('SET_CONTENT_COLLECTION_ATTEMPTED_SUBMISSION');

export const setSessionIdAction = createAction<{ sessionId: ContentCollectionState['sessionId'] }>(
  'SET_CONTENT_COLLECTION_SESSION_ID',
);

export const addUploadingClipToContentCollectionAction = createAction<{
  clip: ContentCollectionClip;
}>('ADD_UPLOADING_CLIP_TO_CONTENT_COLLECTION');

export const deleteContentCollectionClipsAction = createAction<{ clipIds: string[] }>(
  'DELETE_CONTENT_COLLECTION_CLIPS',
);

export const updateContentCollectionClipsAction = createAction<{
  clips: (Partial<ContentCollectionClip> & Pick<ContentCollectionClip, 'id'>)[];
}>('UPDATE_CONTENT_COLLECTION_CLIPS');

export const updateContentCollectionClipCustomFieldAction = createAction<{
  clipId: string;
  customField: ContentCollectionCustomField;
}>('UPDATE_CONTENT_COLLECTION_CLIP_CUSTOM_FIELD');

export const updateContentCollectionCustomFieldsInAllClipsAction = createAction<{
  customField: ContentCollectionCustomField;
}>('UPDATE_CONTENT_COLLECTION_CUSTOM_FIELDS_IN_ALL_CLIPS');

export const setSubmittedContentCollectionClipsAction = createAction<{
  clips: ContentCollectionClipWithUpload[];
}>('SET_SUBMITTED_CONTENT_COLLECTION_CLIPS');

export const setSubmitterNameAction = createAction<{ name: string }>('SET_SUBMITTER_NAME');

export const setFormSubmissionRequiredAction = createAction<{ formSubmissionRequired: boolean }>(
  'SET_FORM_SUBMISSION_REQUIRED',
);

export const setAutoSubmitStatusAction = createAction<{ clipId: string } & ContentCollectionAssetAutoSubmitStatus>(
  'SET_AUTO_SUBMIT_STATUS',
);
